import axios from "axios";
import { toast } from "react-toastify";
import { get, post } from "./api_helper";

const CAL_API_BASE = "https://api.cal.com/v1";
const API_KEY = process.env.REACT_APP_CAL_SECRET;

export const getEventTypes = async () => {
  try {
    const response = await get("/cal/GetEventTypesAsync");
    return response || [];
  } catch (error) {
    toast.error("Failed to load event types");
    throw error;
  }
};

export const getAvailableSlots = async (eventTypeId, startDate, endDate) => {
  try {
    const params = {
      eventTypeId,
      startDate,
      endDate,
    };

    const response = await post("/cal/GetAvailableSlotsAsync", params);
    return response;
  } catch (error) {
    toast.error("Failed to load available slots");
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await post(`/cal//GetUserAsync?userId=${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createBooking = async (bookingData) => {
  try {
    const response = await post("/cal/CreateBookingAsync", bookingData);

    return response;
  } catch (error) {
    toast.error("Failed to create booking");
    throw error;
  }
};
